import React from "react";
import { IItems } from "../../@types/types";

interface NavItemProps {
  item: IItems;
  isFirst: boolean;
  toggleNavItem: (item: IItems | null) => void;
  selectedId: string;
}

const NavItem: React.FC<NavItemProps> = ({
  item,
  isFirst,
  toggleNavItem,
  selectedId,
}) => {
  const { isGroup, targetUrl, title, targetType, id } = item;

  const isPop = targetUrl.includes("popup.php");
  return (
    <li
      className={`nav-item ${isFirst ? "first" : ""} ${
        selectedId === id ? "active" : ""
      }`}
      onClick={(e) => {
        e.stopPropagation();
        if (isGroup) {
          toggleNavItem(item);
        } else {
          toggleNavItem(null);
        }
      }}
      onDoubleClick={() => {
        window.location.href = targetUrl;
      }}
    >
      {isGroup ? (
        <span>{title}</span>
      ) : isPop || targetType === "BLANK" ? (
        <a
          href={targetUrl}
          target='_blank'
          rel='noopener noreferrer'
          className='link'
        >
          {title}
        </a>
      ) : (
        <a href={targetUrl} className='link'>
          {title}
        </a>
      )}
    </li>
  );
};

export default NavItem;
